import { Routes } from "@angular/router";
import { HypothesesPageComponent } from "./hypotheses-page.component";
import { authGuard } from "../../../core/guards/auth.guard";

export const hypothesesPageRoutes: Routes = [
  {
    path: 'records/hypotheses',
    component: HypothesesPageComponent,
    canActivate: [authGuard]
  }
]
